<template>
  <div class="app">
    <Card dis-hover>
      <Form
        :model="form"
        :label-width="60"
        label-position="right"
        style="margin: 10px"
      >
        <Row :gutter="16">
          <Col span="6">
            <FormItem label="选项名称：" :label-width="80">
              <Input v-model="form.Name" placeholder="请输入选项名称"></Input>
              <!-- <Select v-model="form.productionLine" @on-change="choice" placeholder="请选择选项名称">
                                <Option value="">---</Option>
                                <Option v-for="(item, index) in fromFields" :value="item.value" :key="index">
                                    {{ item.name }}
                                </Option>
                            </Select> -->
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="选项组：" :label-width="80">
              <Input v-model="form.Group" placeholder="请输入选项组"></Input>
            </FormItem>
          </Col>
          <!-- <Col span="6">
                        <FormItem label="模具类型：" v-if="mould" :label-width="80">
                            <Select v-model="form.mouldType" placeholder="请选择道具模型">
                                <Option value="">---</Option>
                                <Option v-for="(item, index) in fromFields[3].children" :value="item.value" :key="index">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </FormItem>
                    </Col> -->
          <!-- <Col span="6">
                        <FormItem label="检验类型：" :label-width="80">
                            <Select v-model="form.inspectionType" placeholder="请选择检验类型">
                                <Option value>---</Option>
                                <Option :value="1">工件检验</Option>
                                <Option :value="2">节点检验</Option>
                                <Option :value="3">终检</Option>
                            </Select>
                        </FormItem>
                    </Col> -->
          <Button
            icon="ios-search"
            type="primary"
            size="default"
            @click="getData(1)"
            >查询</Button
          >
          <Button
            icon="md-add"
            type="primary"
            size="default"
            class="toolbar-btn"
            @click="create('新增')"
            >新增</Button
          >
        </Row>
      </Form>
      <div class="table_body" style="margin: -10px 0px 0px 8px">
        <Table
          ref="table"
          border
          :loading="loading"
          :columns="columns"
          :no-data-text="NoDatas"
          :data="tableBody_item"
        ></Table>
        <div style="margin-top: 10px">
          <Page
            show-sizer
            show-total
            class-name="fengpage"
            :total="totalCount"
            class="margin-top-10"
            @on-change="pageChange"
            @on-page-size-change="pagesizeChange"
          ></Page>
        </div>
      </div>
    </Card>
    <create-check
      :value="testModal"
      :type="modelType"
      @close="close"
      ref="newID"
    ></create-check>
    <Modal v-model="deleteModal" class="delete-modal" width="416">
      <div slot="header" class="header">
        <Icon type="ios-help-circle" color="#ff9900"/>提示
      </div>
      <div>是否确认删除？</div>
      <div slot="footer">
        <Button @click="deleteModal = false">否</Button>
        <Button type="primary" @click="deleteRow">是</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import moment from "moment";
import CreateCheck from "./create-check.vue";
export default {
  name: "check",
  props: {},
  components: { CreateCheck },
  filters: {
    formData(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  data() {
    return {
      totalCount: 0, //总共多少页
      current: 1, //当前第几页
      testModal: false,
      deleteModal: false,
      form: {
        Name: "",
        Group:"",
        SkipCount: 0, //从第几条开始爬
        MaxResultCount: 10, //一页多少条
        IncludeCreatoUser: true,
      },
      // form: {
      //     IncludeCreatoUser: true,
      //     productionLine: '',
      //     mouldType: '',
      //     inspectionType: '',
      //     ProjectName: '',
      //     SkipCount: 0, //从第几条开始爬
      //     MaxResultCount: 10, //一页多少条
      // },
      NoDatas: "暂无数据",
      loading: false,
      columns: [],
      tableBody_item: [],
      fromFields: {},
      mould: false,
      modelType: "新增",
      deleteId:0,
    };
  },
  mounted() {
    this.getProductionLne();
    this.getColumns();
    this.getData();
  },
  methods: {
    //页数
    pageChange(size) {
      this.form.SkipCount = (size - 1) * this.form.MaxResultCount;
      this.getData();
    },
    //每页最大条数
    pagesizeChange(size) {
      this.form.MaxResultCount = size;
      this.getData();
    },
    //判断模具框显示隐藏
    // choice(e) {
    //     console.log(e)
    //     if (e == 4) {
    //         this.mould = true;
    //     } else {
    //         this.mould = false;
    //     }
    // },
    //获取下拉列表的查询数据
    async getProductionLne() {
      let res = await this.$Ajax.get(
        "/api/services/app/QualityInspectionPrefabricationProject/GetProductionLine"
      );
      this.fromFields = res.data.result;
      console.log(this.fromFields);
    },
    //获取table数据
    async getData(params) {
      console.log("e", params);
      console.log(this.form);
      if (params == 1) {
        this.form.SkipCount = 0;
      }
      this.loading = true;
      let res = await this.$Ajax.get(`/api/services/app/SelectItem/GetAll`, {
        params: this.form,
      });
      this.tableBody_item = res.data.result.items;
      this.totalCount = res.data.result.totalCount;
      this.loading = false;
      console.log(this.tableBody_item);
    },
    create(type, data) {
      this.modelType = type;
      this.testModal = true;
      this.$refs.newID.getInforID(data ? data.id : null, type);
    },
    //关闭新增编辑弹出框
    close(data) {
      this.testModal = false;
      if (data.cancel) {
        this.getData();
      }
    },
    //table 列
    getColumns() {
      let _this = this;
      this.columns = [
        {
          title: "选项名称",
          key: "name",
        },
        {
          title: "选项值",
          key: "value",
        },
        {
          title: "选项组",
          key: "group",
        },
        {
          title: "创建人",
          key: "creatorUser['userName']",
          render: (h, params) => {
            return h("span", params.row.creatorUser["userName"]);
          },
        },
        {
          title: "创建时间",
          render: (h, params) => {
            return h(
              "span",
              _this
                .$moment(params.row.creationTime)
                .format("YYYY-MM-DD HH:mm:ss")
            );
          },
        },

        {
          title: "操作",
          key: "Actions",
          width: 160,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: async () => {
                      this.create("编辑", params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  on: {
                    click: async () => {
                      this.deleteModal = true
                      this.deleteId = params.row.id
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ];
    },
    async deleteRow(){
      this.deleteModal = false
      const res = await this.$Ajax.delete(`/api/services/app/SelectItem/Delete?id=${this.deleteId}`)
      if(res.success === false){
        return
      }
      this.getData();
      this.$Message.success("操作成功!");
    }
  },
};
</script>

<style lang="less" scoped="scoped">
.app {
  min-width: 1260px;
}
.delete-modal /deep/ .ivu-modal-header {
  border: 0;
}

.delete-modal .header {
  font-size: 20px;
  margin-left: 5px;
  
}
.delete-modal /deep/ .ivu-modal-body {
  font-size: 16px;
  text-align: center;
}
.delete-modal /deep/ .ivu-modal-footer {
  border: 0;
}
</style>
